import { Box } from '@deity/falcon-ui';
import { Select } from '@deity-io/portal-ui';
import type { FC } from 'react';

interface IMethodProps {
  isEditable: boolean;
  contentType: string;
  onChange: (path: string[], val: string) => void;
}
export const ContentType: FC<IMethodProps> = ({ isEditable, contentType, onChange }) => (
  <Box style={{ width: '50%' }}>
    <Select
      label="Content Type"
      sx={{ marginY: 1 }}
      onChange={(val: any) => onChange(['contentType'], val?.value)}
      options={['application/json'].map(m => ({
        value: m,
        label: m.toUpperCase()
      }))}
      value={{ label: contentType?.toUpperCase(), value: contentType }}
      disabled={!isEditable}
      disableClearable
    />
  </Box>
);
